module.exports = __webpack_public_path__ + "static/media/mark-borderless.293fdb86.png";